module.exports = __webpack_public_path__ + "img/1440_tarif.774915d.jpg";